<template>
  <router-link
    :to="to"
    class="tw-flex tw-w-full tw-max-w-full tw-cursor-pointer tw-items-center tw-text-sm tw-tabular-nums tw-text-grey-medium hover:tw-text-blackest"
  >
    {{ prefix }} {{ $filters.formatNumber(safeGet(item, headerKey)) }}
    {{ suffix }}
  </router-link>
</template>
<script>
import ListCellDefault from '@/components/list/cell/default.vue'

export default {
  name: 'ListCellNumber',
  extends: ListCellDefault,
  props: {
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
  },
}
</script>
